import { FieldValues, UseFormSetValue } from 'react-hook-form';
import { BaseSlide } from '../../../../models/slides/BaseSlide';
import { CustomSlide } from '../../../../models/slides/CustomSlide';
import { EventSlide } from '../../../../models/slides/EventSlide';
import { PackageSlide } from '../../../../models/slides/PackageSlide';
import { ProductSlide } from '../../../../models/slides/ProductSlide';
import { fetchEventForPreview } from '../../../../services/eventServices/EventPreviewService';
import { fetchPackagesForPreview } from '../../../../services/packageServices/packagePreviewService';
import { fetchWinesForPreview } from '../../../../services/wineServices/WinePreviewService';
import { emptyEvent } from './event/eventHelper';
import { emptyPackage } from './package/packageHelper';
import { emptyProduct } from './product/productHelper';

export const slideDataUpdater = async ({ slides, setValue }: { slides: BaseSlide[]; setValue: UseFormSetValue<FieldValues> }) => {
  if (!slides) return;
  const updatedSlidesPromise = slides.map(async (slider: BaseSlide, index) => {
    switch (slider.type) {
      case 'CUSTOM':
        const customSlide = slides[index] as CustomSlide;
        return { image: customSlide.image || { alt: '', url: '' }, type: 'CUSTOM', content: customSlide.content };

      case 'PACKAGE':
        const packageSlide = slides[index] as PackageSlide;
        if (!packageSlide.productVariantId) return emptyPackage;

        try {
          const packageElement = (await fetchPackagesForPreview([packageSlide.productVariantId])) as PackageSlide[];
          return {
            type: 'PACKAGE',
            title: packageElement[0]?.title || '',
            id: packageElement[0]?.id || 0,
            productVariantId: packageElement[0]?.productVariantId || 0,
            foregroundImage: packageElement[0]?.foregroundImage || '',
            backgroundImage: packageElement[0]?.backgroundImage || '',
            showWineBottlesInFront: packageElement[0]?.showWineBottlesInFront || false,
            availableQuantity: packageElement[0]?.availableQuantity || 0,
            description: packageElement[0]?.description || '',
            basePrice: packageElement[0]?.basePrice || 0,
            discount: packageElement[0]?.discount || 0,
            currentPrice: packageElement[0]?.currentPrice || 0,
            currentEurPrice: packageElement[0]?.currentEurPrice || 0,
            baseEurPrice: packageElement[0]?.baseEurPrice || 0,
            showEurPrice: packageElement[0]?.showEurPrice || false,
            isManufacturer: packageElement[0]?.isManufacturer || false,
          };
        } catch (error) {
          console.log(error);
        }

      case 'PRODUCT':
        const wineSlide = slides[index] as ProductSlide;
        if (!wineSlide.productVariantId) return emptyProduct;

        try {
          const wineElement = (await fetchWinesForPreview([wineSlide.productVariantId])) as ProductSlide[];
          return {
            imgUrl: wineElement[0]?.imgUrl || '',
            type: 'PRODUCT',
            title: wineElement[0]?.title || '',
            description: wineElement[0]?.description || '',
            id: wineElement[0]?.id || 0,
            productVariantId: wineElement[0]?.productVariantId || 0,
            availableQuantity: wineElement[0]?.availableQuantity || 0,
            basePrice: wineElement[0]?.basePrice || 0,
            discount: wineElement[0]?.discount || 0,
            currentPrice: wineElement[0]?.currentPrice || 0,
            currentEurPrice: wineElement[0]?.currentEurPrice || 0,
            baseEurPrice: wineElement[0]?.baseEurPrice || 0,
            showEurPrice: wineElement[0]?.showEurPrice || false,
            isManufacturer: wineElement[0]?.isManufacturer || false,
            tags: wineElement[0]?.tags || [],
            productYear: wineElement[0]?.productYear || 0,
          };
        } catch (error) {
          console.log(error);
        }

      case 'EVENT':
        const eventSlide = slides[index] as EventSlide;
        if (!eventSlide.id) return emptyEvent;

        try {
          const eventElement = (await fetchEventForPreview(eventSlide.id)) as EventSlide;
          return {
            image: eventElement?.image || '',
            type: 'EVENT',
            title: eventElement?.title || '',
            description: eventElement?.description || '',
            id: eventElement?.id || 0,
            dateFrom: eventElement?.dateFrom || null,
            dateTo: eventElement?.dateTo || null,
            organizer: eventElement?.organizer || '',
            location: eventElement?.location || [],
            ticketPrices: eventElement?.ticketPrices || [],
            animalFriendly: eventElement?.animalFriendly || null,
            disabledFriendly: eventElement?.disabledFriendly || null,
          };
        } catch (error) {
          console.log(error);
        }

      default:
        return null;
    }
  });

  const updatedSlides = await Promise.all(updatedSlidesPromise);
  const filtered = updatedSlides.filter((obj) => obj !== null);

  if (!filtered) return;
  setValue('slideDatas', filtered);
};
